import React from "react"
import "../../assets/scss/components/_copyright.scss"

const Copyright = ({text}) => (
  <p className={'copyright'}>Photo: &copy; {text}</p>
)

export default Copyright
